import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { ProfileModel } from '../../../../core/models/ProfileModel';
import { observer } from 'mobx-react';
import { EmptyWidget } from '../../../../widgets/content/EmptyWidget';
import { faShieldDog } from '@fortawesome/free-solid-svg-icons';
import { ListItemWidget } from '../../../../widgets/controls/list/ListItemWidget';
import { AnimatedCollection, AnimatedCollectionType } from '../../../../widgets/collection/AnimatedCollection';
import { PackModel } from '../../../../core/models/PackModel';
import { AppLink } from '../../../../widgets/utils';

export interface ProfilePacksWidgetProps {
  profile: ProfileModel;
  className?: any;
}

export const ProfilePacksWidget: React.FC<ProfilePacksWidgetProps> = observer((props) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    props.profile.loadPacks().then(() => {
      setLoading(false);
    });
  }, [props.profile]);

  if (!loading && props.profile.packs.length === 0) {
    return <EmptyWidget label="No packs yet!" />;
  }

  return (
    <S.Container className={props.className}>
      <AnimatedCollection<PackModel>
        children={props.profile.packs}
        type={AnimatedCollectionType.SLIDE_IN_LEFT}
        generate_inner={(i) => {
          return (
            <S.PackLink to={i.link} key={i.key} push={true}>
              <ListItemWidget
                label={i.data.name}
                media={{
                  icon: faShieldDog
                }}
                meta={[{ label: i.data.public ? 'Public' : 'Private' }]}
              />
            </S.PackLink>
          );
        }}
      />
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  `;

  export const PackLink = styled(AppLink)`
    text-decoration: none;
    color: inherit;
  `;
}
